<ng-container *ngIf="hasSelectedLayers$ | async">
  <mat-expansion-panel class="d-block d-md-none map-legend-panel" [hideToggle]="true">
    <mat-expansion-panel-header collapsedHeight="40px" expandedHeight="24px">
      <mat-panel-title>
        <span class="title-message">Layers Applied</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="mapLegendTemplate"></ng-container>
  </mat-expansion-panel>
  <div class="d-none d-md-block">
    <ng-container *ngTemplateOutlet="mapLegendTemplate"></ng-container>
  </div>
</ng-container>
<ng-template #mapLegendTemplate>
  <rlst-layer-legend-data *ngIf="plannedLandUseLayer$ | async as plannedLandUseLayer"
    class="legend-row shadow-map-control"
    [layerLabel]="plannedLandUseLayer.label"
    [legendData]="plannedLandUseLegend"
    (closeLayer)="closeBoundaryLayer(plannedLandUseLayer)">
  </rlst-layer-legend-data>

  <rlst-layer-legend-data *ngIf="floodZoneLayer$ | async as floodZoneLayer"
    class="legend-row shadow-map-control"
    [layerLabel]="floodZoneLayer.label"
    [legendData]="floodZoneLegend"
    (closeLayer)="closeBoundaryLayer(floodZoneLayer)">
  </rlst-layer-legend-data>

  <rlst-layer-legend-data *ngIf="faultLineLayer$ | async as faultLineLayer"
    class="legend-row shadow-map-control"
    [layerLabel]="faultLineLayer.label"
    [legendData]="faultLineLegend"
    (closeLayer)="closeBoundaryLayer(faultLineLayer)">
  </rlst-layer-legend-data>

  <rlst-layer-legend-data *ngIf="trendsLayer$ | async as trendsLayer"
    class="legend-row shadow-map-control"
    [layerLabel]="trendsLayer.label"
    [legendData]="trendsLegendData$ | async"
    (closeLayer)="closeTrendLayer()">
  </rlst-layer-legend-data>

  <rlst-layers-legend class="legend-row shadow-map-control"></rlst-layers-legend>
</ng-template>
